import type { MatchEvent } from '../types';

// Shared event toggle (3v3 / 1v1 / ENG) used across Match Control, Practice,
// Bracket, Results, Standings, Fantasy, etc. Enforces 3v3-first ordering by
// convention (pass events in the order you want them shown) and the ENG label
// for 'ec'. Two visual variants to match the existing surfaces without
// changing their look:
//   - 'accent'  : bright accent-filled active tab (control surfaces)
//   - 'subtle'  : bg-3 active tab (public data surfaces)
const label = (v: MatchEvent) => (v === 'ec' ? 'ENG' : v.toUpperCase());

export function EventTabs<T extends MatchEvent>({
  value, onChange, events, variant = 'accent',
}: {
  value: T;
  onChange: (e: T) => void;
  events: readonly T[];
  variant?: 'accent' | 'subtle';
}) {
  return (
    <div className="row r-md border overflow-hidden">
      {events.map((v, i, arr) => {
        const on = value === v;
        if (variant === 'subtle') {
          return (
            <div key={v} onClick={() => onChange(v)}
              className={`mono pad-btn-md txt-12 fw-bold tracking-2 cursor-pointer ${on ? 'bg-3 text-0' : 'text-2'}`}
            >{label(v)}</div>
          );
        }
        return (
          <div key={v} onClick={() => onChange(v)}
            className="pad-btn-md txt-12 fw-bold tracking-2 cursor-pointer"
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              background: on ? 'var(--accent)' : 'transparent',
              color: on ? 'var(--accent-ink)' : 'var(--text-2)',
              borderRight: i < arr.length - 1 ? 'var(--bw) solid var(--line)' : 'none',
            }}
          >{label(v)}</div>
        );
      })}
    </div>
  );
}
